<template>
  <v-flex>
    <router-link
      :to="{
        name: 'projectView',
        params: { projectId }
      }"
    >
      <v-card>
        <router-link
          v-if="project.isDuration()"
          :to="{
            name: 'projectTimerView',
            params: { projectId }
          }"
        >
          <v-btn
            fab
            small
            color="white"
            absolute
            bottom
            left
            class="elevation-4"
          >
            <v-icon>far fa-clock</v-icon>
          </v-btn>
        </router-link>

        <router-link
          v-if="project.isCounter()"
          :to="{
            name: 'projectCheckInView',
            params: { projectId }
          }"
        >
          <v-btn
            fab
            small
            color="white"
            absolute
            bottom
            left
            class="elevation-4"
          >
            <v-icon>fas fa-check</v-icon>
          </v-btn>
        </router-link>
        <v-card-title primary-title>
          <v-layout>
            <v-flex shrink class="ml-2">
              <v-layout column>
                <v-flex class="display-1 display-font">{{
                  ("0" + project.data.index).slice(-2)
                }}</v-flex>
                <div
                  :style="{
                    'background-color': project.data.color,
                    width: '15px',
                    height: '8px'
                  }"
                />
              </v-layout>
            </v-flex>

            <v-flex xs5 md7 class="ml-1" shrink>
              <v-layout column>
                <v-flex class="headline text-wrap" shrink>
                  {{ project.name }}
                </v-flex>

                <router-link
                  v-if="timer && timer.status !== 'READY'"
                  :to="{
                    name: 'projectTimerView',
                    params: { projectId }
                  }"
                >
                  <v-chip
                    :color="timer.status == 'RUNNING' ? 'green' : 'red'"
                    outline
                    label
                    small
                    >{{ timer.status }}</v-chip
                  >
                </router-link>

                <v-flex
                  v-if="!timer || timer.status == 'READY'"
                  class="subtitle-1 description text-wrap"
                  shrink
                  >{{ project.data.description }}</v-flex
                >
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <CalendarHeatMap
                :color="project.data.color"
                :monthRange="0"
                :recordCache="recordCache"
                :config="{
                  label: { height: 0 },
                  domainLabelFormat: '',
                  cellSize: 9,
                  displayLegend: true,
                  legendOrientation: 'vertical',
                  legendVerticalPosition: 'center',
                  legendHorizontalPosition: 'right',
                  legendMargin: [10, 0, 0, 10]
                }"
              />
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
    </router-link>
  </v-flex>
</template>

<script>
import CalendarHeatMap from "@/components/CalendarHeatMap";
export default {
  components: {
    CalendarHeatMap
  },
  props: ["project", "timer", "recordCache", "projectId"]
};
</script>

<style scoped>
/* place holder for empty description */
.text-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.description {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
